import { j as t, T as l } from "./Spinner-yxPaS-Vf.js";
import { styled as p, css as e } from "styled-components";
import { e as i, t as r } from "./index-tc-On6zr.js";
import { o as c, T as h, j as $, e as x, c as o, p as b } from "./style-ImpGK6sv.js";
const u = p.a`
  ${c(h.bodyS)}
  ${$("border-color, text-decoration", x.shortest)}

  display: inline-flex;
  border: 1px solid ${o.greyAlpha10};
  border-radius: 40px;
  background-color: ${o.white};
  padding: ${i.spacer1} ${i.spacer3};
  text-decoration: underline 1px ${o.transparent};
  color: ${o.black};

  ${r({
  dark: e`
      border: 1px solid ${o.greyAlpha10};
      background-color: ${o.whiteAlpha10};
      color: ${o.white};
    `
})}

  &:hover {
    border: 1px solid ${o.black};
    text-decoration: underline 1px ${o.black};

    ${r({
  dark: e`
        text-decoration: underline 1px ${o.white};
      `
})}
  }

  &:active {
    border: 1px solid ${o.black};
    background-color: ${o.greyAlpha10};

    ${r({
  dark: e`
        border: 1px solid ${o.whiteAlpha40};
        background-color: ${o.whiteAlpha10};
      `
})}
  }

  [data-whatintent='keyboard'] &:focus-within {
    outline: ${o.focus} solid 1px;
    outline-offset: 4px;

    ${r({
  dark: e`
        outline: ${o.whiteAlpha10} solid 8px;
        outline-offset: 0;
        border: 1px solid ${o.whiteAlpha10};
      `
})}
  }

  ${b(e`
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  `)}
`, y = ({ text: a, theme: d, href: s, onClick: n }) => /* @__PURE__ */ t.jsx(l, { theme: d, children: a && /* @__PURE__ */ t.jsx(u, { onClick: n, "data-qa": "landing-page-tag", href: s, children: a }) });
export {
  y as L
};
